__turbopack_context__.v({
  "clearArrowWidth": "CollectionContainedDropDownSelect-module__8pYlBW__clearArrowWidth",
  "displayNone": "CollectionContainedDropDownSelect-module__8pYlBW__displayNone",
  "icon": "CollectionContainedDropDownSelect-module__8pYlBW__icon",
  "menuItem": "CollectionContainedDropDownSelect-module__8pYlBW__menuItem",
  "nameContainer": "CollectionContainedDropDownSelect-module__8pYlBW__nameContainer",
  "selectedItem": "CollectionContainedDropDownSelect-module__8pYlBW__selectedItem",
});
